<template>
    <div class="flex-col page">
        <div class="flex-col group_3">
            <div class="flex-col group_4">
                <div class="flex-col items-center">
                    <span class="text_3">{{ couponDetail.couponName }}</span>
                    <span class="text_4">有效期：{{ formatTime(couponDetail.effectTime) }} 至
                        {{ formatTime(couponDetail.expireTime) }}</span>
                </div>
                <div class="flex-col group_6">
                    <div class="flex-col section_1">
                        <div class="justify-between group_7">
                            <span class="text_5">券码</span>
                            <span class="text_6">{{
                                    couponDetail.couponCode
                            }}</span>
                        </div>
                        <div class="divider">
                            <!--*-->
                        </div>
                        <span class="text_7">点击二维码可刷新</span>
                        <div class="flex-col group_8">
                            <img @click="getDetail" :src="couponDetail.qrCode" class="image_4" />
                            <span class="text_8">到店出示二维码，请商家使用小免商户小程序扫描二维码，即可享受服务</span>
                        </div>
                    </div>
                    <div class="flex-col section_2">
                        <div class="justify-between group_9">
                            <span class="text_9">服务类型</span>
                            <span class="text_10">门店</span>
                        </div>
                        <div class="justify-between group_10">
                            <span class="text_11">服务项目</span>
                            <span class="text_12">商务车普洗/SUV普洗/小轿车普洗</span>
                        </div>
                        <div class="flex-col group_11">
                            <div class="justify-between">
                                <span class="text_13">优惠力度</span>
                                <span class="text_14">免费洗车券</span>
                            </div>
                            <div class="justify-between group_13">
                                <span class="text_15">适用车型</span>
                                <span class="text_16">商务车/SUV/小轿车</span>
                            </div>
                            <div class="justify-between group_14">
                                <span class="text_17">适用地域</span>
                                <span class="text_18">全国</span>
                            </div>
                            <div class="justify-between group_15">
                                <span class="text_19">适用门店</span>
                                <div class="flex-row">
                                    <a :href="couponDetail.toUseUrl" class="text_20">查看详情</a>
                                    <img src="https://imgpub1.shouqiev.com/gofunplatform/files/20220819/mEyvglIEcJ.png"
                                        class="image_5" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-col group_17">
                <span class="text_21">使用说明</span>
                <div class="flex-col group_18">
                    <span class="text_22">
                        1.本卷形式为电子卷，出示对应二维码即可使用；<br>
                        2.本卷必须在展示的有效期内使用，过期作废；<br>
                        3.本卷不兑现金，不找零，不可用于其他消费；<br>
                        4.本卷仅限适用地区合作洗车网点使用，网点详情查看商户列表；<br>
                        5.服务车辆限轿车，微型车，跑车，SUV等7座（含）以下车型；<br>
                        6.春节前后一个星期，全国合作商户将暂停提供服务；7.本卷最终解释权由GoFun 所有；<br>
                    </span>
                    <div class="flex-col section_3 footer">
                        <div class="flex-col items-center button">
                            <a :href="couponDetail.toUseUrl" class="text_23">去使用</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCouponDetail } from "../api";
export default {
    data() {
        return {
            couponDetail: {},
        };
    },
    methods: {
        formatTime(time) {
            return time ? time.split(" ")[0] : ''
        },
        getDetail() {
            getCouponDetail({
                couponCode: this.$route.params.id,
            }).then((res) => {
                this.couponDetail = res.result;
            });
        }
    },
    created() {
        this.getDetail()
    },
};
</script>

<style scoped lang="scss">
@import '../common.css';
.page {
    padding-top: 0.027rem;
    background-color: #f5f5f5;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;

    .group_3 {
        padding-top: 0.43rem;
        overflow-y: auto;

        .group_4 {
            padding: 0 0.21rem;

            .group_6 {
                margin-top: 0.43rem;

                .section_1 {
                    padding: 0 0.31rem 0.67rem;
                    background-image: url("https://imgpub1.shouqiev.com/gofunplatform/files/20220819/YSLHaSRWSw.png");
                    background-position: 0% 0%;
                    background-size: 100% 100%;
                    background-repeat: no-repeat;

                    .group_7 {
                        padding: 0.29rem 0 0.27rem;

                        .text_5 {
                            color: #999999;
                            font-size: 0.37rem;
                            font-family: "PingFang SC";
                            line-height: 0.53rem;
                        }

                        .text_6 {
                            margin-right: 0.067rem;
                            color: #333333;
                            font-size: 0.37rem;
                            font-family: "PingFang SC";
                            font-weight: 500;
                            line-height: 0.53rem;
                        }
                    }

                    .divider {
                        background-image: repeating-linear-gradient(90deg,
                                #e0e0e0,
                                #e0e0e0 1.1904761904761905%,
                                transparent 1.1904761904761905%,
                                transparent 2.380952380952381%);
                        border-radius: 0.013rem;
                        height: 0.027rem;
                    }

                    .text_7 {
                        margin-top: 0.67rem;
                        align-self: center;
                        color: #999999;
                        font-size: 0.32rem;
                        font-family: "PingFang SC";
                        line-height: 0.45rem;
                    }

                    .group_8 {
                        margin-top: 0.21rem;
                        align-self: center;
                        width: 7.36rem;

                        .image_4 {
                            align-self: center;
                            border-radius: 0.11rem;
                            width: 4.37rem;
                            height: 4.37rem;
                        }

                        .text_8 {
                            margin-top: 0.43rem;
                            color: #999999;
                            font-size: 0.32rem;
                            font-family: "PingFang SC";
                            line-height: 0.48rem;
                            text-align: center;
                        }
                    }
                }

                .section_2 {
                    margin-top: 0.21rem;
                    padding: 0.29rem 0.29rem 0.29rem 0.32rem;
                    background-color: #ffffff;
                    border-radius: 0.21rem;

                    .group_9 {
                        padding: 0 0.027rem;

                        .text_9 {
                            color: #999999;
                            font-size: 0.37rem;
                            font-family: "PingFang SC";
                            line-height: 0.53rem;
                        }

                        .text_10 {
                            color: #333333;
                            font-size: 0.37rem;
                            font-family: "PingFang SC";
                            line-height: 0.53rem;
                        }
                    }

                    .group_10 {
                        margin-top: 0.27rem;
                        padding-left: 0.027rem;

                        .text_11 {
                            color: #999999;
                            font-size: 0.37rem;
                            font-family: "PingFang SC";
                            line-height: 0.53rem;
                        }

                        .text_12 {
                            color: #333333;
                            font-size: 0.37rem;
                            font-family: "PingFang SC";
                            line-height: 0.53rem;
                        }
                    }

                    .group_11 {
                        margin-top: 0.27rem;

                        .group_13 {
                            margin-top: 0.27rem;

                            .text_15 {
                                color: #999999;
                                font-size: 0.37rem;
                                font-family: "PingFang SC";
                                line-height: 0.53rem;
                            }

                            .text_16 {
                                color: #333333;
                                font-size: 0.37rem;
                                font-family: "PingFang SC";
                                line-height: 0.53rem;
                            }
                        }

                        .group_14 {
                            margin-top: 0.27rem;

                            .text_17 {
                                color: #999999;
                                font-size: 0.37rem;
                                font-family: "PingFang SC";
                                line-height: 0.53rem;
                            }

                            .text_18 {
                                color: #333333;
                                font-size: 0.37rem;
                                font-family: "PingFang SC";
                                line-height: 0.53rem;
                            }
                        }

                        .group_15 {
                            margin-top: 0.27rem;

                            .text_19 {
                                color: #999999;
                                font-size: 0.37rem;
                                font-family: "PingFang SC";
                                line-height: 0.53rem;
                            }

                            .text_20 {
                                color: #999999;
                                font-size: 0.37rem;
                                font-family: "PingFang SC";
                                line-height: 0.53rem;
                            }

                            .image_5 {
                                margin: 0.053rem 0 0.053rem 0.11rem;
                                flex-shrink: 0;
                                width: 0.21rem;
                                height: 0.43rem;
                            }
                        }

                        .text_13 {
                            color: #999999;
                            font-size: 0.37rem;
                            font-family: "PingFang SC";
                            line-height: 0.53rem;
                        }

                        .text_14 {
                            color: #333333;
                            font-size: 0.37rem;
                            font-family: "PingFang SC";
                            line-height: 0.53rem;
                        }
                    }
                }
            }

            .text_3 {
                color: #333333;
                font-size: 0.43rem;
                font-family: "PingFang SC";
                font-weight: 500;
                line-height: 0.59rem;
            }

            .text_4 {
                margin-top: 0.053rem;
                color: #666666;
                font-size: 0.32rem;
                font-family: "PingFang SC";
                line-height: 0.45rem;
            }
        }

        .group_17 {
            margin-top: 0.64rem;

            .text_21 {
                margin-left: 0.43rem;
                align-self: flex-start;
                color: #666666;
                font-size: 0.37rem;
                font-family: "FZLanTingHeiS-R-GB";
                line-height: 0.45rem;
            }

            .group_18 {
                margin-top: 0.21rem;

                .text_22 {
                    margin-left: 0.43rem;
                    margin-right: 0.45rem;
                    color: #999999;
                    font-size: 0.32rem;
                    font-family: "FZLanTingHeiS-R-GB";
                    line-height: 0.48rem;
                    text-align: left;
                    padding-bottom: 150px;
                }

                .section_3.footer {
                    position: fixed;
                    left: 0;
                    right: 0;
                    bottom: 0;

                    margin-top: 0.73rem;
                    padding: 0.32rem 0 0.41rem;
                    background-color: #ffffff;
                    border-top: solid 0.013rem #e0e0e0;

                    .button {
                        margin: 0 0.53rem;
                        padding: 0.29rem 0;
                        background-color: #02d644;
                        border-radius: 0.59rem;

                        .text_23 {
                            color: #ffffff;
                            font-size: 0.43rem;
                            font-family: "PingFang SC";
                            font-weight: 500;
                            line-height: 0.59rem;
                            display: block;
                            width: 100%;
                            height: 100%;
                            text-align: center;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// couponDetail.vue?db5c4d08